/**
 * Apps that render static pages.
 */
export const STATICALLY_RENDERED_APPS = ["visitor-perf"];
